import React, { useState, useEffect  } from "react";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { v4 as uuidv4 } from "uuid"; // For generating unique IDs for components
import DraggableItem from "./DraggableItem/DraggableItem";
import Canvas from "./Canvas/Canvas";
import { Container, Col, Row, Button } from "reactstrap";
import Create_Dashboard_Element from "./Create_Dashboard_Element";
import { set_bread_crum } from '../../slices/header/reducer';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { FETCH_DASHBOARD_LIST, GET_DASHBOARD_ELEMENTS, SAVE_DASHBOARD } from "../../slices/dashboard/thunk";
import { useSelector } from "react-redux";
import { add_component_to_canvas, set_dnd_components } from "../../slices/dashboard/reducer";
import Loader from "../../Components/Common/Loader";
import Custom_Loader from "../../Components/Common/Custom_Loader";
import { tableChartData } from "./MockData";
import Mobile_Dashboard_Component from "./Mobile_Dashboard_Component";

const DragDropCanvas = () => {
    const [components, setComponents] = useState([]); // State to store the dropped components
    const sensors = useSensors(useSensor(PointerSensor)); // Drag sensors setup
    const dispatch = useDispatch();
    const location = useLocation();
    const { Dashboard_Id } = location.state || {};
    const {dashboard_list , dnd_components , dashboard_loader , drag_drop_canvas_loader} = useSelector((state)=>state.Dashboard)
    const dashboard_data = dashboard_list.data?dashboard_list.data[0]:{}

     useEffect(()=>{
        dispatch(set_bread_crum({ title:"Create a dashboard element"  , pageTitle:"Dashboard"  }))

        
    
        return ()=>{
        dispatch(set_bread_crum({ title:""  , pageTitle:""  }))
            
        }
      },[])


      useEffect(() => {
        
        // Get the dashboard details.
        dispatch(FETCH_DASHBOARD_LIST({search_dashboard_id:Dashboard_Id}))

        dispatch(GET_DASHBOARD_ELEMENTS({ dashboard_id:Dashboard_Id  }))

   

      }, [Dashboard_Id])


      useEffect(() => {
        setComponents(dnd_components)
      }, [dnd_components])
      

      
  
    // Function to add a new component
    const addComponent = (comp) => setComponents((prev) => {
      dispatch(set_dnd_components([...dnd_components , comp]))
      return [...prev, comp]
    });
  
    // Function to remove a component
    const removeComponent = (id) =>
      setComponents((prev) => {
        
        dispatch(set_dnd_components(dnd_components.filter((c) => c.id !== id)))
        return dnd_components.filter((c) => c.id !== id)
      
      
      });
  
    // Function to update a component's position or size
    const updateComponent = (id, updates) =>

      setComponents((prev) =>{
        dispatch(set_dnd_components(dnd_components.map((c) => (c.id === id ? { ...c, ...updates } : c))))
        return dnd_components.map((c) => (c.id === id ? { ...c, ...updates } : c))}
      );
  
    // Handling drag end event and updating the position of the dropped component
    const handleDragEnd = (event) => {
    const { active, over } = event;

    if (over && over.id === "canvas") {
        const rect = document.querySelector("#canvas-zone").getBoundingClientRect();

        // Use mouse position relative to canvas
        let x = event.activatorEvent.clientX - rect.left;
        let y = event.activatorEvent.clientY - rect.top;

        // Prevent item from being dropped outside canvas
        const componentWidth = 200;
        const componentHeight = 150;

        x = Math.max(0, Math.min(x, rect.width - componentWidth));
        y = Math.max(0, Math.min(y, rect.height - componentHeight));

        const newComponent = {
        id: uuidv4(),
        type: active.data.current.type,
        x: x,
        y: y,
        // width: componentWidth,
        // height: componentHeight,
        width: null,
        height: null,
        };

        addComponent(newComponent);
        
    }
    };


    const handleDashboardSave = ()=>{
        const elements = dnd_components.map((ele,index)=>{
          const { id , type , x , y , width , height , title , favorite_prompt_id , data , X_Axis_Column , Y_Axis_Column , Labelling_Column , Theta_Column , xPercent , yPercent } = ele
 
            console.log("Values of X on saving ----->",xPercent)
            console.log("Values of Y on saving ----->",yPercent)

             return{
              element_id:id,
              favorite_prompt_id,
              graph_element_title:title,
              graph_json:data,
              graph_type:type,
              height,
              width,
              x_axis_position:x,
              y_axis_position:y,
              x_axis_column:X_Axis_Column,
              y_axis_column:Y_Axis_Column ,
              labelling_column:Labelling_Column,
              theta_column:Theta_Column,
              xPercent,
              yPercent


             }
        })
        
        const post_data = {
          dashboard_id:Dashboard_Id,
          elements
        }


        dispatch(SAVE_DASHBOARD(post_data))


    }


// const add_component_to_canvas = ({ type, data }) => {
//   const rect = document.querySelector("#canvas-zone").getBoundingClientRect();

//   const componentWidth = 200;
//   const componentHeight = 150;

//   // Random x and y within canvas bounds
//   const x = Math.floor(Math.random() * (rect.width - componentWidth));
//   const y = Math.floor(Math.random() * (rect.height - componentHeight));

//   const newComponent = {
//     id: uuidv4(),
//     type,
//     x,
//     y,
//     width: null,
//     height: null,
//     data
//   };

//   addComponent(newComponent);
// };
  
    return (
      <React.Fragment>
            <div className="page-content top-p-80">
                <Container fluid>
                    
                        <Row>
                            <Col>
                               
                                <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                                <div className="dragdrop_wrap">
                                <div className="dragdrop_wrap_drag_inner">
                                {/* Sidebar with draggable items */}
                                    <div className="w-64 border-r space-y-4 d-flex justify-content-between">
                                         <h2 className="text-lg font-bold ">{dashboard_data?.Dashboard_Title}</h2>
                                            <div className="w-64 border-r space-y-4 cde mb-3">
                                            <Create_Dashboard_Element />
                                            <Button disabled={drag_drop_canvas_loader} onClick={handleDashboardSave} className="save_chart">Save</Button>                                     
                                        </div>
                                                                               
                                    </div>
                                    
                                </div>
                                    {/* Canvas where components will be dropped */}
                                    <div className="dragdrop_wrap_drop_component">
                                      {drag_drop_canvas_loader ? <Custom_Loader />
                                        : (
                                          <>
                                            <Canvas
                                              components={components}
                                              addComponent={addComponent}
                                              removeComponent={removeComponent}
                                              updateComponent={updateComponent}
                                            />
                                            <Mobile_Dashboard_Component />
                                          </>
                                        )
                                        }
                                    </div>                                   
                             </div>
                                
                            </DndContext>


                            </Col>
                            
                        </Row>
                    
                </Container>
            </div>
           
        </React.Fragment>
    );
  };
  
  export default DragDropCanvas;